module.exports = __webpack_public_path__ + "img/crm.3bdc136a.svg";